import { BodyText, Flex, Subtitle, theme } from 'modules/ui';
import styled from 'styled-components';

export const StyledWrapper = styled(Flex)`
  min-height: 5.063rem;
  height: auto;
  margin-bottom: 2rem;
  background: ${({theme}) => theme.colors.primaryT2};
  padding: 0.938rem;
  gap: 0.313rem;
  user-select: none;
`;

export const StyledTitle = styled(Subtitle)`
  margin-bottom: 0;
  color: ${({theme}) => theme.colors.primaryW};
  line-height: 1.375rem;
`;

export const StyledDescription = styled(BodyText)`
  margin-bottom: 0;
  color: ${({theme}) => theme.colors.primaryW};
`;
